import React from "react";

import { Props } from "./types";

function FileInput(props: Props) {
  return (
    <input
      type="file"
      value=""
      accept={props.accepts ? props.accepts.join(", ") : ""}
      className={props.className}
      onChange={({ target }) =>
        target.files &&
        target.files.length > 0 &&
        target.files[0] &&
        props.input({
          size: target.files[0].size,
          name: target.files[0].name,
          type: target.files[0].type,
          uri: URL.createObjectURL(target.files[0]),
        })
      }
    />
  );
}

export { FileInput };
